export default __webpack_public_path__ + "static/media/plus.17be1f3a.svg";